import {useState} from 'react'
import { IAnnualEvaluationDocument } from '../../../../../interface';
import { BsTrashFill, BsFillPlusCircleFill } from 'react-icons/bs';
const GoalsComponent = ({selectedAnnualDocument, setter}:{selectedAnnualDocument:IAnnualEvaluationDocument, setter:Function}) => {
  const [evaluationSummaryTable, setEvaluationSummaryTable] = useState<any[]>(
    []
   );
 
  return (
    <>
     <table className="table table-bordered position-relative">
                {
                  //@ts-ignore
                }{" "}
                <tbody>
                  <tr>
                    {selectedAnnualDocument.evaluationSummary.columns.map(
                      (column, index) => {
                        return (
                          <td key={index}>
                            <strong>{column}</strong>
                          </td>
                        );
                      }
                    )}
                  </tr>
                  {evaluationSummaryTable.map((t: [], i) => {
                    return (
                      <>
                        <tr className="position-relative" key={i}>
                          {t.map((c, x) => (
                            <td key={x}>
                              <input
                              key={x}
                                type="text"
                                className="form-control"
                                placeholder="empty value"
                                value={evaluationSummaryTable[i][x]}
                                onChange={({target})=>{
                                  const theValue = target.value;
                                  //method to manipulate this sh1t
                                  let clonedArray = [...evaluationSummaryTable]
                                  clonedArray[i][x] = theValue;
                                  setEvaluationSummaryTable(clonedArray)
                                  setter(evaluationSummaryTable)
                                 
                                }}
                              />
                            </td>
                          ))}
                          <div
                            onClick={() => {
                              const filtered = evaluationSummaryTable.filter(
                                (r, x) => x !== i
                              );
                              setEvaluationSummaryTable(filtered);
                              setter(evaluationSummaryTable)
                            }}
                            className="btn small position-absolute"
                            style={{
                              top: 0,
                              right: 0,
                              marginRight: -30,
                              fontSize: 16,
                              marginTop: 5,
                              color:"red"
                            }}
                          >
                            <BsTrashFill />
                          </div>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>

              <div
                className="btn btn-primary m-2"
                onClick={() => {
                  const arrayOfArray = new Array(
                    selectedAnnualDocument.evaluationSummary.columns.length
                  ).fill("");
                  const anotherRow = [...evaluationSummaryTable, arrayOfArray];
                  setEvaluationSummaryTable(anotherRow);
                  setter(evaluationSummaryTable)
                }}
              >
                <BsFillPlusCircleFill /> Add row
              </div>
       
             
              <p className="mt-4">
                {selectedAnnualDocument.evaluationSummary.notes}
              </p></>
  )
}

export default GoalsComponent